
import { IconBadge, IconCalendar, openModal } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'

import translations from './ReassuranceButtons.translations'

export default {
  components: {
    IconBadge,
    IconCalendar,
  },
  computed: {
    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
    }),
    translations: () => translations,
  },
  methods: {
    deploySatisfactionModal() {
      openModal(MODAL_NAMES.REASSURANCE.SATISFACTION)
    },
  },
}
